var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('waterfall-flow',{ref:"waterfall",scopedSlots:_vm._u([_vm._l((_vm.noteList),function(note){return {key:note.id,fn:function(){return [_c('NoteCard',{key:note.id,attrs:{"note":note}})]},proxy:true}})],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }